import { useCallback, useContext, useDebugValue } from 'react';
import * as StorageService from '@root/lib/services/StorageService';
import * as PREService from '@root/lib/services/PREService';
import context from '.';

/**
 * @return {[
 *   null|{
 *     zipcode: string;
 *     transit_time: string;
 *     zone: string;
 *     transit_days: number;
 *   },
 *   (region: Object) => void,
 * ]}
 */
const useRegion = () => {
  const { state, functions } = useContext(context);

  /**
   * Sets the region
   * 
   * @type {(region: Object) => void}
   */
  const setRegion = useCallback((region) => {
    StorageService.setRegion(region);
    PREService.setOrderDataZip(region.zipcode);

    return functions.setRegionProxy(region);
  }, [functions.setRegionProxy]);

  useDebugValue(state.region);
  return [state.region, setRegion];
}

export default useRegion;